import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DoctorSocialService } from '../doctor-social.service';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { ReportDialogComponent } from '../report-dialog/report-dialog.component';

@Component({
  selector: 'app-story-details-dialog',
  templateUrl: './story-details-dialog.component.html',
  styleUrls: ['./story-details-dialog.component.css']
})
export class StoryDetailsDialogComponent implements OnInit {

  postDetails
  views;

  storiesIds: any[] = []
  currentStory;

  @ViewChild('slickModal') slickModal: SlickCarouselComponent;

  barProgress: boolean = false


  slideConfigureForDoctor = {
    infinite: false,
    dots: true,
    autoplay: false,
    variableWidth: false,
    draggable: false,
    rtl: false,
    arrows: false,
    slidesToShow: 1,
    mouseWheelMove: false,
  };

  constructor(
    public dialogRef: MatDialogRef<StoryDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private service: DoctorSocialService,
    private toaster: ToastrService,
    public app: AppService
  ) { }

  ngOnInit(): void {
    this.slideConfig();
    this.storiesIds = this?.data?.storysIds
    this.currentStory = this?.data?.storysIds[0]

    let firstStory = this?.currentStory?.storiesAttr?.find(x => x?.iViewdStory == false)
    if (firstStory) {
      setTimeout(() => {
        let indexOfFirstStory = this?.currentStory?.storiesAttr?.findIndex(item => item?.postId == firstStory?.postId);
        this.goToSlide(indexOfFirstStory)
        this.varCurrentSlide = indexOfFirstStory
        this.getPostById(firstStory?.postId);
      }, 100);
    } else {
      // firstStory = this.currentStory.storiesAttr[0]
      setTimeout(() => {
        this.goToSlide(0)
        this.varCurrentSlide = 0
        this.getPostById(this?.currentStory?.storiesAttr[0]?.postId);
      }, 100);
    }
  }

  goToSlide(slideNumber: number) {
    this?.slickModal?.slickGoTo(slideNumber);
  }

  allowToSlide: boolean = true
  handleImages() {
    this.barProgress = false
    if (this?.varCurrentSlide == this?.currentStory?.storiesAttr?.length - 1) {
      setTimeout(() => {
        if (this.allowToSlide == true) {
          if (this?.varCurrentMainSlideIndex == this?.storiesIds?.length - 1) {
            this.cancel();
          } else {
            this.varCurrentMainSlideIndex = this?.varCurrentMainSlideIndex + 1
            this.varCurrentSlide = null
            this.currentStory = this.storiesIds[this.varCurrentMainSlideIndex]
            this.goToSlide(0)
          }
        }
        this.allowToSlide = true
      }, 5000);
    } else {
      setTimeout(() => {
        if (this.allowToSlide == true) {
          this?.slickModal?.slickNext()
        }
        this.allowToSlide = true
      }, 5000);
    }
  }

  onVideoStarted() {
    this.barProgress = false
  }

  onVideoEnded() {
    if (this?.varCurrentSlide == this?.currentStory?.storiesAttr?.length - 1) {
      if (this.allowToSlide == true) {
        if (this?.varCurrentMainSlideIndex == this?.storiesIds?.length - 1) {
          this.cancel();
        } else {
          this.varCurrentMainSlideIndex = this?.varCurrentMainSlideIndex + 1
          this.varCurrentSlide = null
          this.currentStory = this.storiesIds[this.varCurrentMainSlideIndex]
          this.goToSlide(0)
        }
      }
      this.allowToSlide = true
    } else {
      if (this.allowToSlide == true) {
        this?.slickModal?.slickNext()
      }
      this.allowToSlide = true
    }
  }

  varCurrentMainSlideIndex = 0
  varCurrentSlide = null
  afterChangeSlide(currentSlide: number) {
    if (this.varCurrentSlide > currentSlide) {
      this.allowToSlide = false
    }
    if (this?.varCurrentSlide != currentSlide) {
      if (this?.varCurrentSlide > currentSlide) {
        this.allowToSlide = true
      }
      this.varCurrentSlide = currentSlide
      this.postDetails = null
      this.views = null
      let postIdAtIndex = this?.currentStory?.storiesAttr[currentSlide]?.postId
      this.getPostById(postIdAtIndex);
    }
  }

  getPostById(id) {
    this.barProgress = true
    this.service.getPostById(id).subscribe(
      res => {
        if (res.errorCode == 0) {
          this.postDetails = res?.data
          if(res?.data?.isMyPost == true){
            this.getPostViews(id);
          }
        } else if (res.errorCode != 0) {
          if (this?.app?.getUserLanguage() == 'en') {
            this.toaster.error("Something went wrong");
          } else if (this?.app?.getUserLanguage() == 'ar') {
            this.toaster.error("حدث خطأ ما");
          }
          this.dialogRef.close(null)
        }
      }
    )
  }

  getPostViews(id) {
    this.service.getPostViews(id, 99, 1).subscribe(
      res => {
        this.views = res?.data?.data
      }
    )
  }

  cancel(): void {
    this.dialogRef.close(true);
  }

  
  reportPost() {
    this.slickModal.slickPause()
    this.allowToSlide = false
    let id = this?.postDetails?.postId
    const dialogRef = this.dialog.open(ReportDialogComponent, {
      width: '33%',
      data: { id },
      panelClass: 'modalBoxScroll'
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res == true) {
        this.cancel();
      }else {
        this.allowToSlide = true
        this?.slickModal?.slickPlay();
        this?.slickModal?.slickNext();
      }
    });
  }

  deleteStory() {
    // if (this?.postDetails?.isMyPost == false) { return }
    this?.slickModal?.slickPause();
    this.allowToSlide = false
    this.service.deleteMyPost(this?.postDetails?.postId).subscribe(
      res => {
        if (res.errorCode == 0) {
          if (this?.app?.getUserLanguage() == 'en') {
            this.toaster.success("Story Deleted Successfully ");
          } else if (this?.app?.getUserLanguage() == 'ar') {
            this.toaster.success("تم حذف القصة بنجاح");
          }
          this.cancel();
        }
      }
    )

  }

  // SlideSettings
  slideConfig() {
    if (this?.app?.getUserLanguage() == 'ar') {
      this.slideConfigureForDoctor.rtl = true
    }
  }


}
